var map = {
	"./menu-approval.svg": "3xhb",
	"./menu-audit.svg": "DM6P",
	"./menu-commission.svg": "tn24",
	"./menu-company.svg": "usAi",
	"./menu-home.svg": "1Kzt",
	"./menu-project.svg": "0WDK",
	"./menu-task.svg": "LsbB"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "B67Z";


//////////////////
// WEBPACK FOOTER
// ./src/icons/menu nonrecursive \.svg$
// module id = B67Z
// module chunks = 13